import { render } from "./3dView.vue?vue&type=template&id=206ac824&ts=true"
import script from "./3dView.vue?vue&type=script&lang=ts"
export * from "./3dView.vue?vue&type=script&lang=ts"

import "./3dView.vue?vue&type=style&index=0&id=206ac824&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__